import {DateTime} from 'luxon'

import {Locale} from '@/utils/constants'

import {getTimezoneFullname} from './luxon'

export const DEFAULT_DATE_FORMAT = 'LLL dd, yyyy'

export const formatDate = (date: string, language: string, isShort?: boolean, format?: string) => {
  const formats = {
    short: 'LLLL, yyyy',
    long: 'MMMM dd, yyyy',
    longEU: 'dd.MM.yyyy',
  }

  const formatType = isShort ? 'short' : Locale.en === language ? 'long' : 'longEU'

  return DateTime.fromISO(date)
    .reconfigure({locale: language})
    .toFormat(format || formats[formatType])
}

export const getDaysInMonth = (month: number, year: number) => {
  // for February
  if (month === 2) {
    return (year % 4 === 0 && year % 100) || year % 400 === 0 ? 29 : 28
  }
  const monthsWith30days = [4, 6, 9, 11]
  return monthsWith30days.includes(month) ? 30 : 31
}

export const formatDateAndTime = (
  date: string,
  locale: Locale,
  timezone?: string,
  showTimezone?: boolean,
) => {
  const isEnLanguage = locale === Locale.en

  const currentDate = DateTime.now()
  let isoDate = DateTime.fromISO(date).reconfigure({locale})

  if (timezone) {
    isoDate = isoDate.setZone(timezone)
  }

  const isCurrentYear = currentDate.year === isoDate.year
  const isCurrentMonth = currentDate.month === isoDate.month
  const isCurrentDay = currentDate.day === isoDate.day
  const isToday = isCurrentYear && isCurrentMonth && isCurrentDay

  const enFormat = isToday ? 'hh:mm a' : isCurrentYear ? 'LLL dd' : DEFAULT_DATE_FORMAT
  const defaultFormat = isToday ? 'HH:mm' : isCurrentYear ? 'd. LLL' : 'd. LLL yyyy'

  const format = isEnLanguage ? enFormat : defaultFormat

  let result = isoDate.toFormat(format)

  if (timezone && showTimezone) {
    result = result + ` (${getTimezoneFullname(timezone)})`
  }

  return result
}

export const getDaysSince = (date: string) =>
  Math.floor(DateTime.now().diff(DateTime.fromISO(date), 'days').days)
